
<table id="{{Id}}-counts-table" class="table emds-table table-sticky-header table-fixed table-striped table-selected-row messages-count-table">
  <thead>
    <tr>
      <th class="message-type" id="{{Id}}-header-type" translate>Type</th>
      <th *ngFor="let messageUrgencyItem of messageUrgencies; let i = index" class="urgency-{{i}}" id="{{Id}}-header-{{i}}" translate [style.color]="messageUrgencyItem.Color">{{messageUrgencyItem.Name}}</th>
    </tr>

  </thead>
  <tbody>
    <ng-container>
      <tr *ngFor="let messageCountItem of messageCounts; let i = index">
        <td id="{{Id}}-row-{{i}}-type" translate>{{messageCountItem.TypeName}}</td>
        <td id="{{Id}}-row-{{i}}-urgency" *ngFor="let messageUrgency of messageCountItem.MessageUrgencies" translate [style.color]="messageUrgency.urgencyColor">{{messageUrgency.urgencyCount}}</td>
      </tr>
    </ng-container>
  </tbody>
</table>
